import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=c20ad656"
import script from "./ShiftList.js?vue&type=script&lang=js&external"
export * from "./ShiftList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports